// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AttributeSelection_dropdown__1P0OM"};